import { render } from "./CreatePhysicianRow.vue?vue&type=template&id=ecc72ec2&ts=true"
import script from "./CreatePhysicianRow.ts?vue&type=script&lang=ts&external"
export * from "./CreatePhysicianRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__